@custom-media --mobile (max-width: 768px);

.container {
  margin-top: 2em;
}

.listing {
  font-weight: bold;
  font-size: 0.8em;
  margin-bottom: 4em;

  & tbody {
    border: 1px solid var(--mediumSilver);
  }

  @media (--mobile) {
    margin-bottom: 2em;
  }
}

.row {
  & td {
    padding: 2em 1.5em;
    min-width: 5em;
  }

  & .statusCell {
    width: 12em;
  }

  & .selectCell {
    width: 4em;
  }
}

.row:nth-child(odd) {
  background-color: var(--white);
}

.row:nth-child(even),
.rowHeader {
  background-color: var(--silver);
}

.header {
  & th {
    padding-left: 1.5em;
    padding-top: 1em;
    min-width: 4em;
  }
}

.status {
  text-align: right;

  p {
    margin-bottom: 0;
  }
}

.statusIcon {
  padding-left: 0.5em;
}
